import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import AttendanceTable from "../components/AttendanceTable";
import axios from "axios";
import { BACKEND_URL } from "../data/config";

const EmployeeAttendancePage = () => {

  const { id } = useParams();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [pagination, setPagination] = useState({
    page: 1,
    pages: 0,
    total: 0
  });

  const loadData = async (page = 1) => {

    setLoading(true);

    try {

      const params = new URLSearchParams({
        employee_id: id,
        page: page.toString()
      });

      const response = await axios.get(
        `${BACKEND_URL}/api/employee-attendance.php?${params}`
      );

      if (response.data.success) {

        setData(response.data.data);

        setPagination({
          page: response.data.pagination.page,
          pages: response.data.pagination.pages,
          total: response.data.pagination.total
        });

      }

    } catch (error) {

      console.error("Loading error:", error);

    } finally {

      setLoading(false);

    }

  };

  useEffect(() => {
    loadData(1);
  }, [id]);

  const handlePageChange = (page) => {
    loadData(page);
  };

  return (

    <div className="min-h-screen bg-gray-100">

      <Navbar />

      <div className="max-w-6xl mx-auto p-6">

        <div className="mb-6">

          <h1 className="text-2xl font-semibold text-gray-900">
            Employee Attendance
          </h1>

          <p className="text-sm text-gray-500 mt-1">
            Employee ID: {id}
          </p>

        </div>

        <AttendanceTable data={data} loading={loading} />

        {pagination.pages > 1 && (

          <div className="flex justify-between items-center mt-6 text-sm">

            <div className="text-gray-500">
              {pagination.total} records
            </div>

            <div className="flex gap-2">

              <button
                onClick={() => handlePageChange(pagination.page - 1)}
                disabled={pagination.page === 1}
                className="px-3 py-1 border rounded disabled:opacity-40"
              >
                Previous
              </button>

              <span className="px-3 py-1">
                Page {pagination.page} / {pagination.pages}
              </span>

              <button
                onClick={() => handlePageChange(pagination.page + 1)}
                disabled={pagination.page === pagination.pages}
                className="px-3 py-1 border rounded disabled:opacity-40"
              >
                Next
              </button>

            </div>

          </div>

        )}

      </div>

    </div>

  );

};

export default EmployeeAttendancePage;